import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Field,
  reduxForm,
  reset,
  submit,
  stopSubmit,
  setSubmitFailed,
} from "redux-form";
import _ from "lodash";
import moment from "moment";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import TimePicker from "react-bootstrap-time-picker";
import { timeFromInt } from "time-number";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  addCoupon,
  updateCoupon,
  openTicketModal,
  editCoupon,
  couponExist,
} from "TicketAction";
import {
  COMMON_FAIL_MESSAGE,
  validateOnlyNums,
  maxLengthObjectFc,
  DISPLAY_LOCAL_DATE_FORMAT,
  DATE_FORMAT,
  checkDateFormatYMD,
} from "Constants";
import { isEmpty } from "BaseFunctions";
import LocaleStrings from "Languages";
var MAXLENOBJ = {};

class AddCoupon extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = { loading: false, dateError: {} };

    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.onSubmitForm = this.onSubmitForm.bind(this);
  }

  componentDidMount() {
    MAXLENOBJ = maxLengthObjectFc(this.props.history);
  }

  openModal() {
    this.props.editCoupon({});
    this.props.openTicketModal(true);
  }

  closeModal() {
    this.props.reset();
    this.props.openTicketModal(false);
  }

  onSubmitForm(values) {
    // console.log("values :- ", values);
    if (values.startdate && values.enddate) {
      var startdate =
        typeof values.startdate === "string"
          ? moment(values.startdate, DISPLAY_LOCAL_DATE_FORMAT).format(
              "YYYY-MM-DD"
            )
          : moment(values.startdate).format("YYYY-MM-DD");
      var enddate =
        typeof values.enddate === "string"
          ? moment(values.enddate, DISPLAY_LOCAL_DATE_FORMAT).format(
              "YYYY-MM-DD"
            )
          : moment(values.enddate).format("YYYY-MM-DD");
      // console.log("startdate", startdate);
      // console.log("enddate", enddate);

      var starttime = values.starttime ? values.starttime : "0:00";
      var endtime = values.endtime ? values.endtime : "0:05";
      var starttimeIsFormatted = _.split(starttime, ":").length > 1;
      var endtimeIsFormatted = _.split(endtime, ":").length > 1;
      if (!starttimeIsFormatted) {
        starttime = timeFromInt(parseInt(starttime));
        starttime =
          _.split(starttime, ":").length === 2 ? `${starttime}:00` : starttime;
      }
      if (!endtimeIsFormatted) {
        endtime = timeFromInt(parseInt(endtime));
        endtime =
          _.split(endtime, ":").length === 2 ? `${endtime}:00` : endtime;
      }
      var discountstart = `${startdate} ${starttime}`;
      var discountend = `${enddate} ${endtime}`;
      // console.log("discountstart", discountstart);
      // console.log("discountend", discountend);

      if (discountstart && discountend && discountend > discountstart) {
        this.setState({ loading: true });
        values.discountstart = discountstart;
        values.discountend = discountend;
        if (this.props.editMode) {
          // Used promo record
          let orderList =
            this.props.orderList && this.props.orderList.totalOrder
              ? this.props.orderList.totalOrder
              : "";
          var couponCodeUsed = [];
          if (orderList && orderList.length > 0) {
            _.map(orderList, (order) => {
              if (order.couponcode != "") {
                if (typeof couponCodeUsed[order.couponcode] === "undefined") {
                  couponCodeUsed[order.couponcode] = 1;
                } else {
                  couponCodeUsed[order.couponcode] =
                    parseInt(couponCodeUsed[order.couponcode]) + 1;
                }
              }
            });
          }
          if (couponCodeUsed[values.couponcode] > values.usagelimit) {
            this.setState({ loading: false });
            var errorMessage =
              LocaleStrings.tickets_coupon_form_validation_coupon_usage_limit_cannot_reduce_than_already_used_coupon +
              " " +
              couponCodeUsed[values.couponcode];
            let dateError = { usageslimiterror: errorMessage };
            this.setState({ dateError: dateError });
            this.props.dispatch(setSubmitFailed("CouponForm", "usagelimit"));
            this.props.dispatch(
              stopSubmit("CouponForm", new Error(errorMessage))
            );
            setTimeout(() => {
              this.setState({ dateError: {} });
            }, 2000);
          } else {
            this.props.updateCoupon(values, this.props.session, (response) => {
              if (response.success === 0) {
                this.setState({ loading: false });
                this.props.showError(COMMON_FAIL_MESSAGE);
              } else {
                this.setState({ loading: false });
                this.props.showSuccess(
                  LocaleStrings.tickets_coupon_form_coupon_updated_success
                );
                this.closeModal();
              }
            });
          }
        } else {
          this.props.couponExist(
            this.props.session,
            values.couponcode,
            (ticketresponse) => {
              if (ticketresponse.success) {
                this.props.addCoupon(this.props.session, values, (response) => {
                  if (response.success === 0) {
                    this.setState({ loading: false });
                    this.props.showError(COMMON_FAIL_MESSAGE);
                  } else {
                    this.setState({ loading: false });
                    this.props.showSuccess(
                      LocaleStrings.tickets_coupon_form_coupon_added_success
                    );
                    this.closeModal();
                  }
                });
              } else {
                this.setState({ loading: false });
                var errorMessage =
                  LocaleStrings.tickets_coupon_form_validation_coupon_already_exists;
                let dateError = { ticketnameerror: errorMessage };
                this.setState({ dateError: dateError });
                this.props.dispatch(
                  setSubmitFailed("CouponForm", "couponcode")
                );
                this.props.dispatch(
                  stopSubmit("CouponForm", new Error(errorMessage))
                );
                setTimeout(() => {
                  this.setState({ dateError: {} });
                }, 2000);
              }
            }
          );
        }
      } else {
        var errorMessage = "";
        var enderrorMessage = "";
        if (!startdate) {
          errorMessage = LocaleStrings.tickets_coupon_form_validation_required;
        }
        if (!enddate) {
          enderrorMessage =
            LocaleStrings.tickets_coupon_form_validation_required;
        } else if (discountend <= discountstart) {
          enderrorMessage =
            LocaleStrings.tickets_coupon_form_validation_end_date_should_greater_equal_than_start_date;
        }
        let dateError = {
          startdateError: errorMessage,
          enddateError: enderrorMessage,
        };
        this.setState({ dateError: dateError });
        this.props.dispatch(setSubmitFailed("CouponForm", "startdate"));
        this.props.dispatch(setSubmitFailed("CouponForm", "enddate"));
        this.props.dispatch(stopSubmit("CouponForm", new Error(errorMessage)));
        this.props.dispatch(
          stopSubmit("CouponForm", new Error(enderrorMessage))
        );
        setTimeout(() => {
          this.setState({ dateError: {} });
        }, 2000);
      }
    } else {
      var errorMessage = "";
      var enderrorMessage = "";
      if (!values.startdate) {
        errorMessage = LocaleStrings.tickets_coupon_form_validation_required;
      }
      if (!values.enddate) {
        enderrorMessage = LocaleStrings.tickets_coupon_form_validation_required;
      }

      let dateError = {
        startdateError: errorMessage,
        enddateError: enderrorMessage,
      };
      this.setState({ dateError: dateError });

      this.props.dispatch(setSubmitFailed("CouponForm", "startdate"));
      this.props.dispatch(setSubmitFailed("CouponForm", "enddate"));
      this.props.dispatch(stopSubmit("CouponForm", new Error(errorMessage)));
      this.props.dispatch(stopSubmit("CouponForm", new Error(enderrorMessage)));
      setTimeout(() => {
        this.setState({ dateError: {} });
      }, 2000);
    }
  }

  render() {
    var { handleSubmit, pristine, reset, submitting, invalid, editMode } =
      this.props;
    var edit = editMode;

    return (
      <div>
        <span className="pull-right">
          <button
            type="button"
            className="btn btn-custom-blue"
            onClick={this.openModal}
          >
            {/* <i className="fa fa-plus i-custom-m"></i>{LocaleStrings.button_create_discount} */}
            <img
              style={{ paddingRight: 8, paddingBottom: 3 }}
              src="../../style/images/header-icons/plus.png"
            ></img>
            {LocaleStrings.button_create_discount}
          </button>
        </span>
        <div>
          <Modal
            className="modal-container"
            dialogClassName="modal-md"
            show={this.props.showModal === true ? true : false}
            animation={true}
          >
            <form onSubmit={handleSubmit(this.onSubmitForm)}>
              <Modal.Header>
                <div className="import-modal-title">
                  {edit
                    ? LocaleStrings.tickets_coupon_title_edit_coupon
                    : LocaleStrings.tickets_coupon_title_add_coupon}
                </div>
                <button
                  type="button"
                  className="i-custom-cross-popup pull-right"
                  onClick={() => this.closeModal()}
                >
                  <img
                    className="i-custom-small"
                    src="../../style/images/custom-icons/cross-black.png"
                  />
                </button>
              </Modal.Header>
              <Modal.Body className="scrollable-modal">
                <div>
                  <AddCouponForm
                    editMode={this.props.editMode}
                    dateError={this.state.dateError}
                    initialValues={this.props.initialValues}
                    ticketList={this.props.ticketList}
                  />
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="btn btn-custom-white"
                  onClick={this.closeModal}
                >
                  {LocaleStrings.button_close}
                </Button>
                <Button
                  className="btn btn-custom-blue ml-10"
                  loading={this.state.loading}
                  disabled={pristine || invalid || submitting}
                  type="submit"
                >
                  {LocaleStrings.button_save}
                </Button>
              </Modal.Footer>
            </form>
          </Modal>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var toEdit = !isEmpty(state.EditCoupon);
  var initVals = {};

  if (toEdit) {
    initVals = state.EditCoupon;

    initVals.startdate = moment(initVals.startdate).format(DATE_FORMAT);
    initVals.enddate = moment(initVals.enddate).format(DATE_FORMAT);
  } else {
    initVals = { starttime: "0:00", endtime: "0:05" };
  }

  return {
    session: state.session,
    showModal: state.showTicketModal,
    initialValues: initVals,
    editMode: !_.isEmpty(state.EditCoupon),
    ticketList: state.allTicketList,
    orderList: state.OrderList,
  };
}

function validate(values) {
  var errors = {};
  var couponcode = values["couponcode"];
  var usagelimit = values["usagelimit"];
  var coupontype = values["coupontype"];
  var amount = values["amount"];
  var enddate = values["enddate"];
  var startdate = values["startdate"];
  var starttime = values["starttime"];
  var endtime = values["endtime"];
  var discountfor = values["discountfor"];
  var status = values["status"];

  if (!couponcode) {
    errors["couponcode"] =
      LocaleStrings.tickets_coupon_form_validation_required;
  }
  if (!discountfor) {
    errors["discountfor"] =
      LocaleStrings.tickets_coupon_form_validation_required;
  }
  if (!usagelimit) {
    errors["usagelimit"] =
      LocaleStrings.tickets_coupon_form_validation_usases_limit;
  } else if (usagelimit && !validateOnlyNums(usagelimit)) {
    errors["usagelimit"] =
      LocaleStrings.tickets_coupon_form_validation_usases_limit;
  }
  if (!coupontype) {
    errors["coupontype"] =
      LocaleStrings.tickets_coupon_form_validation_required;
  }
  if (!amount) {
    errors["amount"] = LocaleStrings.tickets_coupon_form_validation_required;
  }
  if (!startdate) {
    errors["startdate"] = LocaleStrings.tickets_coupon_form_validation_required;
  }
  if (!enddate) {
    errors["enddate"] = LocaleStrings.tickets_coupon_form_validation_required;
  }
  if (!starttime) {
    errors["starttime"] = LocaleStrings.tickets_coupon_form_validation_required;
  }
  if (!endtime) {
    errors["endtime"] = LocaleStrings.tickets_coupon_form_validation_required;
  }
  if (startdate && enddate && starttime && endtime) {
    if (typeof startdate === "string") {
      if (!checkDateFormatYMD(startdate)) {
        startdate = moment(startdate, `${DISPLAY_LOCAL_DATE_FORMAT}`).format(
          DATE_FORMAT
        );
      } else {
        startdate = moment(startdate).format(DATE_FORMAT);
      }
    } else {
      startdate = moment(startdate).format(DATE_FORMAT);
    }
    if (typeof enddate === "string") {
      if (!checkDateFormatYMD(enddate)) {
        enddate = moment(enddate, `${DISPLAY_LOCAL_DATE_FORMAT}`).format(
          DATE_FORMAT
        );
      } else {
        enddate = moment(enddate).format(DATE_FORMAT);
      }
    } else {
      enddate = moment(enddate).format(DATE_FORMAT);
    }

    var starttimeIsFormatted = _.split(starttime, ":").length > 1;
    var endtimeIsFormatted = _.split(endtime, ":").length > 1;
    if (!starttimeIsFormatted) {
      starttime = timeFromInt(parseInt(starttime));
      starttime =
        _.split(starttime, ":").length === 2 ? `${starttime}:00` : starttime;
    }
    if (!endtimeIsFormatted) {
      endtime = timeFromInt(parseInt(endtime));
      endtime = _.split(endtime, ":").length === 2 ? `${endtime}:00` : endtime;
    }
    var discountstart = `${startdate} ${starttime}`;
    var discountend = `${enddate} ${endtime}`;

    if (discountend <= discountstart) {
      errors["dateerror"] =
        LocaleStrings.tickets_coupon_form_validation_end_date_should_greater_equal_than_start_date;
    }
  }
  if (!status) {
    errors["status"] = LocaleStrings.tickets_coupon_form_validation_required;
  }

  if (values["couponcode"] && MAXLENOBJ) {
    if (values["couponcode"].length > MAXLENOBJ.couponcode) {
      errors["couponcode"] =
        LocaleStrings.max_characters_left + MAXLENOBJ.couponcode;
    }
  }

  return errors;
}

export default connect(mapStateToProps, {
  addCoupon,
  updateCoupon,
  openTicketModal,
  showError,
  showSuccess,
  editCoupon,
  couponExist,
})(
  reduxForm({
    validate,
    form: "CouponForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(AddCoupon)
);

class AddCouponForm extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      starttime: { start: "0:00", end: "23:55" },
      endtime: { start: "0:05", end: "23:55" },
      step: 5,
      amountOfftxt: "",
    };
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.editMode) {
      if (nextProps.initialValues.coupontype) {
        var txt =
          nextProps.initialValues.coupontype == "percentage"
            ? "% off each ticket"
            : "off each ticket";
        this.setState({ amountOfftxt: txt });
      }
    }
  };

  changeCodeType = (e) => {
    var selected = e.target.value;

    if (selected != "") {
      var txt =
        selected == "percentage" ? "% off each ticket" : "off each ticket";
      this.setState({ amountOfftxt: txt });
    } else {
      this.setState({ amountOfftxt: "" });
    }
  };

  renderGroupFieldText(field) {
    let amountOfftxt = field.amountOfftxt;
    var divClassName = `form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;

    let labelClasses = "control-label-top col-sm-12";
    let inputClasses = "input-group mb-3 col-sm-12 col-sm-offset-0";
    var inputClasses_amountOfftxt =
      "input-group mb-3 col-sm-12 col-sm-offset-0 wrapper-custom-border";

    return (
      <div className={divClassName}>
        <label className={labelClasses}>
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>

        {amountOfftxt != "" ? (
          <div className={inputClasses_amountOfftxt}>
            <input
              className="form-control"
              type={field.type}
              placeholder={field.placeholder}
              {...field.input}
              min={field.min ? field.min : ""}
              disabled={field.disabled ? field.disabled : false}
            />
            <span className="input-group-addon">{amountOfftxt}</span>
          </div>
        ) : (
          <div className={inputClasses}>
            <input
              className="form-control"
              type={field.type}
              placeholder={field.placeholder}
              {...field.input}
              min={field.min ? field.min : ""}
              disabled={field.disabled ? field.disabled : false}
            />
          </div>
        )}
        <div className="text-help label-text-help" style={{ paddingLeft: 15 }}>
          {field.meta.touched ? field.meta.error : ""}
        </div>
      </div>
    );
  }

  renderTimeField = (field) => {
    var divClassName = `form-group row ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    return (
      <div className={divClassName}>
        {/* <label className="control-label col-sm-3">
        {field.label}<span className="label-mandatory">{(field.mandatory === 'true')?'*':''}</span>
        </label> */}
        <div className="col-sm-12 col-sm-offset-0">
          <TimePicker
            start={field.start}
            end={field.end}
            step={field.step}
            className="form-control dropdown-height-border"
            placeholder={field.placeholder}
            {...field.input}
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const minDate = new Date();
    // console.log("minDate", minDate);
    let ticketList =
      this.props.ticketList && this.props.ticketList.resource
        ? this.props.ticketList.resource
        : "";

    let disCountList = [{ name: LocaleStrings.all, value: "all" }];
    if (ticketList && ticketList.length > 0) {
      _.map(this.props.ticketList.resource, (tindex) => {
        if (tindex.tickettype !== "free") {
          disCountList.push({ name: tindex.ticketname, value: tindex.id });
        }
      });
    }
    let codeTypeOptions = [
      {
        name: LocaleStrings.tickets_coupon_form_label_code_type_option1,
        value: "percentage",
      },
      {
        name: LocaleStrings.tickets_coupon_form_label_code_type_option2,
        value: "amount",
      },
    ];

    return (
      <div className="basicform">
        <div className="row">
          <div className="col-md-12" style={{ padding: 0 }}>
            <Field
              name="couponcode"
              label={LocaleStrings.tickets_coupon_form_label_code_name}
              placeholder={LocaleStrings.tickets_coupon_form_ph_code_name}
              type="text"
              component={this.renderFieldText}
              mandatory="true"
              disabled={this.props.editMode}
              maxlength={MAXLENOBJ.couponcode ? MAXLENOBJ.couponcode : ""}
              labelposition={LABEL_POSITION_TOP}
            />
            {this.props.dateError.ticketnameerror !== "" ? (
              <div style={{ paddingLeft: 15 }}>
                <span style={{ color: "#d43f3a" }}>
                  {this.props.dateError.ticketnameerror}
                </span>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12" style={{ padding: 0 }}>
            <Field
              name="discountfor"
              label={LocaleStrings.tickets_coupon_form_label_discount_for}
              placeholder={LocaleStrings.tickets_coupon_form_ph_discount_for}
              type="select"
              mandatory="true"
              component={this.renderSelect}
              opts={disCountList}
              disabled={this.props.editMode}
              labelposition={LABEL_POSITION_TOP}
            />
          </div>
          <div
            className="col-md-12"
            style={{ paddingLeft: 0, paddingRight: 0 }}
          >
            <Field
              name="usagelimit"
              label={LocaleStrings.tickets_coupon_form_label_usage_limit}
              placeholder={LocaleStrings.tickets_coupon_form_ph_usage_limit}
              type="number"
              component={this.renderFieldText}
              mandatory="true"
              min="1"
              labelposition={LABEL_POSITION_TOP}
            />
            {this.props.dateError.usageslimiterror !== "" ? (
              <div style={{ paddingLeft: 15 }}>
                <span style={{ color: "#d43f3a" }}>
                  {this.props.dateError.usageslimiterror}
                </span>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12" style={{ padding: 0 }}>
            <Field
              name="coupontype"
              label={LocaleStrings.tickets_coupon_form_label_code_type}
              placeholder={LocaleStrings.tickets_coupon_form_ph_code_type}
              type="select"
              mandatory="true"
              component={this.renderSelect}
              opts={codeTypeOptions}
              onChange={this.changeCodeType}
              disabled={this.props.editMode}
              labelposition={LABEL_POSITION_TOP}
            />
          </div>
          <div
            className="col-md-12"
            style={{ paddingLeft: 0, paddingRight: 0 }}
          >
            <Field
              name="amount"
              label={LocaleStrings.tickets_coupon_form_label_amount_off}
              placeholder={LocaleStrings.tickets_coupon_form_ph_amount_off}
              type="number"
              amountOfftxt={this.state.amountOfftxt}
              component={this.renderGroupFieldText}
              mandatory="true"
              min="1"
              disabled={this.props.editMode}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-7">
            <Field
              label={
                LocaleStrings.tickets_coupon_form_label_discount_start_from
              }
              name="startdate"
              type="text"
              component={this.renderDatePicker}
              mandatory="true"
              minDate={minDate}
              labelposition={LABEL_POSITION_TOP}
            />
          </div>
          <div
            className="col-md-5"
            style={{ paddingLeft: 5, paddingRight: 0, paddingTop: 34 }}
          >
            <Field
              name="starttime"
              label=""
              placeholder=""
              type="text"
              mandatory="true"
              start={this.state.starttime.start}
              end={this.state.starttime.end}
              component={this.renderTimeField}
              step={this.state.step}
            />
          </div>
          <div className="col-md-12">
            {this.props.dateError.startdateError !== "" ? (
              <span style={{ color: "#d43f3a" }}>
                {this.props.dateError.startdateError}
              </span>
            ) : (
              ""
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-md-7">
            <Field
              name="enddate"
              label={LocaleStrings.tickets_coupon_form_label_discount_ends_at}
              type="text"
              component={this.renderDatePicker}
              mandatory="true"
              minDate={minDate}
              labelposition={LABEL_POSITION_TOP}
            />
          </div>
          <div className="col-md-5" style={{ paddingTop: 34 }}>
            <Field
              name="endtime"
              label=""
              placeholder=""
              type="text"
              mandatory="true"
              start={this.state.endtime.start}
              end={this.state.endtime.end}
              component={this.renderTimeField}
              step={this.state.step}
            />
          </div>
          <div className="col-md-12">
            <Field
              name="dateerror"
              type="text"
              component={this.renderHiddenFieldText}
            />
          </div>
          <div className="col-md-12">
            {this.props.dateError.enddateError !== "" ? (
              <span style={{ color: "#d43f3a" }}>
                {this.props.dateError.enddateError}
              </span>
            ) : (
              ""
            )}
          </div>
        </div>

        <div className="form-group row">
          <label className="control-label-top col-sm-12 m-0 ">
            {LocaleStrings.tickets_coupon_form_label_status}
            <span className="label-mandatory">*</span>
          </label>
          <div className="col-md-12 vertical-align-center">
            <Field
              name="status"
              label={LocaleStrings.tickets_coupon_form_label_status_option1}
              component={this.renderFieldRadio}
              type="radio"
              value="enabled"
            />{" "}
            <Field
              name="status"
              label={LocaleStrings.tickets_coupon_form_label_status_option2}
              component={this.renderFieldRadio}
              type="radio"
              value="disabled"
            />
          </div>
        </div>
      </div>
    );
  }
}
